
export class WaiterLoginModel {
    public pin: string = "";
    public VenueId: string;
}